import useTranslate from 'hooks/useTranslate'
import React from 'react'

const DetailTab = ({detailTabStatus, setDetailTabStatus}) => {
    const {t} = useTranslate()
    const detailTabList = [
        {
            id: 1,
            name : t('goodTogether')
        },
        {
            id: 2,
            name : t('nutritionalValues')
        },
        {
            id: 3,
            name : t('allergens')
        },
    ]
  return (
    <div className='detailTabs'>
        {
            detailTabList.map((detailList,i) => (
                <div className={`${detailTabStatus == detailList.id ? "detailTabs-active" : "detailTabs-passive"}`} onClick={() => setDetailTabStatus(detailList.id)} key={i}>{detailList.name}</div>
            ))
        }
    </div>
  )
}

export default DetailTab